import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Map Pin icon for representing locations or places
 */
export const MapPinIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
      <circle cx="12" cy="10" r="3"></circle>
    </Icon>
  );
};

export default MapPinIcon;
